import 'isomorphic-fetch';
import { Environment, Store, RecordSource, Network } from 'relay-runtime';
import serverVars from 'server-vars';
import { getBuyerToken } from 'dibs-cookie-jar';
import { createFetcher } from 'dibs-relay-network-layer/client';
import { setupSubscriptions } from 'dibs-relay-network-layer/subscriptionsClient';
import { subscriptionEventHandlers } from './utils/subscriptionMessageBus';

const userType = 'buyer';
export function clientRelayEnvironment(records, options) {
    const { locale } = options || {};
    const getQueries = () => ({
        ...getBuyerToken(document.cookie),
        locale: locale || serverVars.get('locale'),
    });
    const network = Network.create(
        createFetcher({ getQueries, userType }),
        setupSubscriptions({ getQueries, userType, eventHandlers: subscriptionEventHandlers })
            .fetchOrSubscribe
    );
    const source = new RecordSource(records);
    const store = new Store(source);

    return new Environment({ network, store });
}
